// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Soak Time Onboarding Component
// ═══════════════════════════════════════════════════════════════════════════
// One-time overlay asking users to select their preferred soak time
// ═══════════════════════════════════════════════════════════════════════════

import { getSoakTime, setSoakTime, setSoakTimeOnboarded } from '../services/storage.js';
import { logSoakTimeChange, logButtonTap } from '../services/analytics.js';

let currentOverlay = null;

const SOAK_OPTIONS = [
  { seconds: 10, label: '10 seconds', description: 'Quick reflection' },
  { seconds: 30, label: '30 seconds', description: 'Recommended' },
  { seconds: 60, label: '60 seconds', description: 'Deep meditation' },
];

export function showSoakTimeOnboarding(onComplete) {
  if (currentOverlay) return;

  const overlay = document.createElement('div');
  overlay.className = 'soak-onboarding-overlay';
  overlay.id = 'soak-onboarding-overlay';

  const currentSoakTime = getSoakTime();

  overlay.innerHTML = `
    <div class="soak-onboarding-panel">
      <div class="soak-onboarding-icon">🕐</div>
      
      <h2 class="soak-onboarding-title">Take Your Time</h2>
      
      <p class="soak-onboarding-text">
        We encourage you to spend a few moments with each verse 
        before moving on. How long would you like to soak in each verse?
      </p>
      
      <div class="soak-options">
        ${SOAK_OPTIONS.map(opt => `
          <button class="soak-option ${opt.seconds === currentSoakTime ? 'selected' : ''}" 
                  data-seconds="${opt.seconds}">
            <span class="soak-option-time">${opt.label}</span>
            <span class="soak-option-desc">${opt.description}</span>
          </button>
        `).join('')}
      </div>
      
      <button class="soak-onboarding-continue" id="soak-continue">
        Continue
      </button>
      
      <p class="soak-onboarding-note">
        You can change this anytime in Settings
      </p>
    </div>
  `;

  document.body.appendChild(overlay);
  currentOverlay = overlay;

  // Animate in
  requestAnimationFrame(() => {
    overlay.classList.add('active');
  });

  // Track selected value
  let selectedSeconds = currentSoakTime;

  // Option selection
  overlay.querySelectorAll('.soak-option').forEach(btn => {
    btn.addEventListener('click', () => {
      const seconds = parseInt(btn.dataset.seconds);
      selectedSeconds = seconds;

      // Update UI
      overlay.querySelectorAll('.soak-option').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');

      logButtonTap('soak_option', 'onboarding', null);
    });
  });

  // Continue button
  overlay.querySelector('#soak-continue').addEventListener('click', () => {
    const previousTime = getSoakTime();
    setSoakTime(selectedSeconds);
    setSoakTimeOnboarded();

    if (previousTime !== selectedSeconds) {
      logSoakTimeChange(previousTime, selectedSeconds);
    }

    logButtonTap('soak_continue', 'onboarding', null);

    // Animate out
    overlay.classList.remove('active');
    setTimeout(() => {
      overlay.remove();
      currentOverlay = null;
      if (onComplete) onComplete();
    }, 300);
  });
}

export function hideSoakTimeOnboarding() {
  if (currentOverlay) {
    currentOverlay.classList.remove('active');
    setTimeout(() => {
      currentOverlay?.remove();
      currentOverlay = null;
    }, 300);
  }
}

export default { showSoakTimeOnboarding, hideSoakTimeOnboarding };
